<template>
    <section id="welcome" style="padding-top: 200px;margin-bottom:50px; text-align:center" >
        <div style="display:table-cell; vertical-align: middle; text-align: -webkit-center" >
            <div style="margin-bottom:30px">
            <logo></logo>

      
            </div>
             <img src="public/images/site/background-welcome-stain.svg" alt="Arkidia">  
        </div>
        


        
    </section>
</template>

<script>
import Logo from '../animations/Logo.vue'


  export default {
    name: 'app',
    data () {
      return {
       

      }
    },
    methods:{
      irLogin(){
        sessionStorage.usuario = ""
        sessionStorage.nombre = ""
        this.$router.push({path:'/Login'})
      },
      irRegister(){
        this.$router.push({path:'/Register'})
      }


    },
    computed:{

    }
        ,
    components:{
           Logo: Logo,

    },

    mounted: function(){

    },


  }
</script>

<style>

.ingreso{
  margin:30px;
  border-radius: 15px !important; 
  border: 0px !important;
  width: 250px;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  cursor: pointer;
}
.ingreso:hover{
  box-shadow: -1px 11px 16px 1px rgba(0,0,0,0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

.logo-inicio{
  display:block;
  padding-bottom:60px;
  max-width:600px;
  margin:auto;
}

@media screen and (max-width: 600px) {
  .logo-inicio {
    width: 80%;
    margin:20px;

  }
}

</style>


// WEBPACK FOOTER //
// src/components/startPage/InicialEmpresas.vue